import { oz } from '@weft/utils';

export const SANDBOX_ENVIRONMENTS = Object.freeze({
  AI_DATA: 'AI & Data',
  FINTECH: 'Fintech',
  CLOUD: 'Cloud',
  SAAS: 'SAAS',
  DEV_TOOLS: 'Dev. Tools',
  SERVICES_OTHERS: 'Services and Others',
});

export const SandboxEnvironmentSchema = oz.nativeEnum(SANDBOX_ENVIRONMENTS).openapi('SandboxEnvironment');

export type SandboxEnvironment = oz.infer<typeof SandboxEnvironmentSchema>;
